import { render, staticRenderFns } from "./AddressBookLayout.vue?vue&type=template&id=615ae60a&scoped=true&"
import script from "./AddressBookLayout.vue?vue&type=script&lang=js&"
export * from "./AddressBookLayout.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookLayout.vue?vue&type=style&index=0&id=615ae60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ae60a",
  null
  
)

component.options.__file = "AddressBookLayout.vue"
export default component.exports